module.exports = __webpack_public_path__ + "static/media/QmeritQIndiqo.b0f1350b.svg";